var map = {
	"./danish": 84712,
	"./danish.js": 84712,
	"./dutch": 43867,
	"./dutch.js": 43867,
	"./english": 68777,
	"./english.js": 68777,
	"./finnish": 22374,
	"./finnish.js": 22374,
	"./flemish": 76453,
	"./flemish.js": 76453,
	"./french": 83433,
	"./french.js": 83433,
	"./german": 70179,
	"./german.js": 70179,
	"./irish": 24396,
	"./irish.js": 24396,
	"./italian": 42561,
	"./italian.js": 42561,
	"./norwegian": 45237,
	"./norwegian.js": 45237,
	"./portuguese": 88532,
	"./portuguese.js": 88532,
	"./spanish": 16609,
	"./spanish.js": 16609,
	"./swedish": 69312,
	"./swedish.js": 69312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90997;